export const Types = {
  SAVE_LIST_CATEGORY: 'SAVE_LIST_CATEGORY',
  SAVE_LIST_POST: 'SAVE_LIST_POST',
  SAVE_LIST_TAG: 'SAVE_LIST_TAG',
  SAVE_ALL_TAG: 'SAVE_ALL_TAG',
  SAVE_LIST_POST_CATEGORY: 'SAVE_LIST_POST_CATEGORY',
  SAVE_LIST_POST_AGENCY: 'SAVE_LIST_POST_AGENCY',
  SAVE_LIST_AGENCY_POST: 'SAVE_LIST_AGENCY_POST',
  SAVE_LIST_AUTHOR_CMS: 'SAVE_LIST_AUTHOR_CMS',
  SAVE_LIST_EXPERT_CMS: 'SAVE_LIST_EXPERT_CMS',
  SAVE_LIST_CATEGORY_SEO_CMS: 'SAVE_LIST_CATEGORY_SEO_CMS'
}
